import { render, staticRenderFns } from "./UnclearWords.vue?vue&type=template&id=618468d0"
import script from "./UnclearWords.vue?vue&type=script&lang=js"
export * from "./UnclearWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports